import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import { Alert, Box, CircularProgress } from "@mui/material";
import AddState from "../components/AddState";
import Onboarding from "../components/Onboarding";
import AgentService from "../services/agent.service";
import { useAuth } from "../hooks/useAuth";

// #57 - white glove: a principal prepares an Add State request FOR one of
// their hierarchy agents (?agent=<id>). Mirrors the contract flow: seed from
// the TARGET agent's prefill, route through the missing-fields screen first
// when their record is incomplete. Authorization is server-side.
const OnBehalfAddState = ({ agentId }) => {
  const [prefill, setPrefill] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setPrefill(null);
    AgentService.prefillFor(agentId)
      .then(setPrefill)
      .catch(() => setError("This agent isn't available to your account."));
  }, [agentId]);
  useEffect(load, [load]);

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }
  if (!prefill) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", padding: 6 }}>
        <CircularProgress />
      </Box>
    );
  }
  if ((prefill.missingFields || []).length) {
    return (
      <Onboarding
        targetPrefill={prefill}
        targetMissing={prefill.missingFields}
        onSaved={load}
      />
    );
  }
  return (
    <AddState
      initialData={{ onBehalfOfAgent: agentId }}
      agentOverride={prefill}
    />
  );
};

const AddStateRoute = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const onBehalfAgentId =
    user?.role === "agency" ? searchParams.get("agent") : null;
  return (
    <Layout>
      <Box sx={{ padding: 4 }}>
        {onBehalfAgentId ? (
          <OnBehalfAddState agentId={onBehalfAgentId} />
        ) : (
          <AddState />
        )}
      </Box>
    </Layout>
  );
};

export default AddStateRoute;
